import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchInstalledApps } from "../../../../../shell/store/apps";
import { StorefrontRounded, PowerRounded } from "@mui/icons-material";
import { AppState } from "../../../../../shell/store/types";
import { useHistory } from "react-router";
import { AppSideBar, SubMenu } from "../../../../../shell/components/AppSidebar";
import { Box, Stack, Skeleton, Typography } from "@mui/material";
import { IconButton as IconButtonCustom } from "@zesty-io/material";
import { AddRounded } from "@mui/icons-material";
export const Sidebar = () => {
  const {
    t
  } = useTranslation();
  const installedApps = useSelector((state: AppState) => state.apps.installed);
  const isLoadingApps = useSelector((state: AppState) => state.apps.isLoadingApps);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchInstalledApps());
    if (installedApps.length) {
      history.push(`/apps/${installedApps[0]?.ZUID}`);
    }
  }, []);
  const apps: SubMenu[] = useMemo(() => {
    if (installedApps.length) {
      return installedApps.map(app => {
        return {
          name: app.label,
          path: `/apps/${app.ZUID}`,
          icon: PowerRounded
        };
      });
    }
    return [];
  }, [installedApps]);
  return <AppSideBar data-cy="apps-nav" mode="dark" headerTitle={t("marketplace.headerTitleApps")} onAddClick={() => window.open("https://www.zesty.io/marketplace/apps/", "_blank")} subMenus={[{
    name: t("marketplace.sidebarMarketplace"),
    path: "",
    icon: StorefrontRounded,
    disableActive: true,
    onClick: () => window.open("https://www.zesty.io/marketplace/apps/", "_blank")
  }, ...apps]} withSearch={false} titleButtonTooltip={t("marketplace.visitMarketplace")} isLoading={isLoadingApps} data-sentry-element="AppSideBar" data-sentry-component="Sidebar" data-sentry-source-file="Sidebar.tsx" />;
};